import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
};

export const MaximizedChartDialog: FC<Props> = ({ open, onClose, children }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth={false}
			fullWidth
			slotProps={{
				paper: {
					sx: {
						borderRadius: "8px",
						width: "95vw",
						maxWidth: "95vw",
						height: "85vh",
						maxHeight: "85vh",
					},
				},
			}}
		>
			<DialogContent
				sx={{
					p: 2,
					display: "flex",
					flexDirection: "column",
					position: "relative",
				}}
			>
				<Box sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}>
					<IconButton size="small" onClick={onClose}>
						<Close fontSize="small" />
					</IconButton>
				</Box>
				<Box sx={{ flex: 1, width: "100%", height: "100%", py: 4 }}>{children}</Box>
			</DialogContent>
		</Dialog>
	);
};
